import { SlugifiedAttributesFilterValue } from 'services/providers/bapi/entities/filters/normalize'
import { TranslateFnType } from 'store'

export const getStyleGroupFilterTitle = (
  t: TranslateFnType,
  styleGroupFilter: SlugifiedAttributesFilterValue,
) => {
  switch (styleGroupFilter.id) {
    case '3': // Used to be "modern"
      return t('Klassisch')
    default:
      return styleGroupFilter.name
  }
}
